<script>
    import { toast } from "$service/toast";
    import { goto } from "$app/navigation";
    import { Label, Input, Spinner } from 'flowbite-svelte';
    import { register } from "../../service/http_calls";

    let email = "";
    let password = "";
    let confirmPassword = "";
    let loading = false;

    async function handleSignup(event) {
       event.preventDefault();

       if (password !== confirmPassword) {
          toast.push("Incorrect password, please check", { type: 'error' });
          return;
       }

       try {
          loading = true;
          const response = await register(email, password);
          loading = false;
          if (response.status === "OK") {
             toast.push("Signup successful, please log in.", { type: 'success' });
             goto("/login");
          } else {
             toast.push(response.detail.message, { classes: ["warn"] });
          }
       } catch (error) {
          toast.push("An error occurred. Please try again later.", { classes: ["warn"] });
          console.error(error);
       }
    }

    function handleKeyDown(event) {
       if (event.key === "Enter") {
          handleSignup(event);
       }
    }
</script>

<div class="flex justify-center items-center min-h-screen bg-cream font-geist">
   <div class="bg-white border border-card-border rounded-2xl shadow-purple-float p-10 w-full max-w-md mx-4">

      <div class="text-center mb-8">
         <h2 class="text-2xl font-bold text-navy">Create your account</h2>
         <p class="text-sm text-purple-sub mt-1">Get started with SmartClaim</p>
      </div>

      <form on:submit|preventDefault={handleSignup} class="space-y-5">
         <div>
            <Label for="email" class="block mb-1.5 text-sm font-medium text-gray-700">Email</Label>
            <Input
               type="email"
               bind:value={email}
               placeholder="name@email.com"
               class="w-full"
               on:keydown={handleKeyDown}
               required
            />
         </div>

         <div>
            <Label for="password" class="block mb-1.5 text-sm font-medium text-gray-700">Password</Label>
            <Input
               type="password"
               autocomplete="new-password"
               bind:value={password}
               placeholder="Enter your password"
               class="w-full"
               on:keydown={handleKeyDown}
               required
            />
            <p class="mt-1.5 text-xs text-gray-500">At least 12 characters. Common passwords are not accepted.</p>
         </div>

         <div>
            <Label for="confirmPassword" class="block mb-1.5 text-sm font-medium text-gray-700">Confirm Password</Label>
            <Input
               type="password"
               autocomplete="new-password"
               bind:value={confirmPassword}
               placeholder="Re-enter your password"
               class="w-full"
               on:keydown={handleKeyDown}
               required
            />
         </div>

         {#if loading}
            <div class="flex justify-center py-2">
               <Spinner />
            </div>
         {:else}
            <button
               type="submit"
               class="w-full bg-navy text-white py-3 rounded-full font-semibold text-sm hover:opacity-90 transition"
            >
               Sign Up
            </button>
         {/if}
      </form>

      <div class="text-center mt-5">
         <span class="text-sm text-gray-500">Already have an account? </span>
         <a href="/login" class="text-sm text-navy font-medium hover:opacity-70 transition underline">
            Log in
         </a>
      </div>
   </div>
</div>
